/**
 * Пресеты акцентного цвета (источник истины — reference/app.jsx → ACCENTS).
 *
 * Акцент — это не один токен: при смене пресета на <html> переписывается сразу
 * несколько CSS custom properties. Каждый пресет задаёт:
 *  - `p`   — основной цвет / цвет свотча,
 *  - `g`   — конечный цвет градиента,
 *  - `a`   — средний цвет текста (читаемый на обеих темах: eyebrow, ссылки, курсор),
 *  - `rgb` — для альфы в тенях,
 *  - `dark` / `light` — оттенки фоновых blob'ов под текущую тему.
 */
export interface AccentPreset {
  name: string
  p: string
  g: string
  a: string
  rgb: string
  dark: [string, string, string]
  light: [string, string, string]
}

/** Ключ пресета — это его primary-цвет (`p`), как в референсе. */
export const ACCENTS: Record<string, AccentPreset> = {
  '#2f6bff': { name: 'Cyber', p: '#2f6bff', g: '#19e3ff', a: '#2f9bff', rgb: '47, 107, 255', dark: ['#11235e', '#0b2f6b', '#0a3a5e'], light: ['#c6d8fc', '#bfeafb', '#cdf2fb'] },
  '#5b5bff': { name: 'Grape', p: '#5b5bff', g: '#9b4dff', a: '#7c6dff', rgb: '91, 91, 255', dark: ['#20206e', '#2f1f7a', '#3a1f72'], light: ['#d0d0fe', '#e0d2fe', '#e6d2fb'] },
  '#8b2fe6': { name: 'Ultraviolet', p: '#8b2fe6', g: '#e23bdb', a: '#b14df0', rgb: '139, 47, 230', dark: ['#3a1066', '#521178', '#5e1268'], light: ['#e8d2fb', '#f1d2fb', '#f5d0f3'] },
  '#d6249f': { name: 'Bubblegum', p: '#d6249f', g: '#ff5fa2', a: '#ec4899', rgb: '214, 36, 159', dark: ['#4d0e44', '#5e1052', '#6b124a'], light: ['#f6d0ed', '#fbd0e8', '#fbcfe2'] },
  '#ff2d72': { name: 'Flamingo', p: '#ff2d72', g: '#ff7a59', a: '#ff5a8a', rgb: '255, 45, 114', dark: ['#5e1030', '#6b182a', '#71221c'], light: ['#fbd0e0', '#fed7d0', '#fedccf'] },
  '#ff5a3c': { name: 'Sunset', p: '#ff5a3c', g: '#ffb020', a: '#ff7043', rgb: '255, 90, 60', dark: ['#5e1e10', '#6b3a10', '#71500f'], light: ['#fed8cf', '#fde9c0', '#fdf0bc'] },
  '#ff8a00': { name: 'Tangerine', p: '#ff8a00', g: '#ffd000', a: '#ff9e1b', rgb: '255, 138, 0', dark: ['#5e3410', '#6b4a0c', '#71560c'], light: ['#fde6bc', '#fdefb0', '#fdf6b0'] },
  '#9ade00': { name: 'Acid', p: '#9ade00', g: '#16e0c9', a: '#74b300', rgb: '154, 222, 0', dark: ['#314d05', '#1a4d33', '#0c4a45'], light: ['#e6f9a0', '#cffadf', '#bff5ee'] },
  '#00c27a': { name: 'Tropic', p: '#00c27a', g: '#00d4ff', a: '#00b06e', rgb: '0, 194, 122', dark: ['#06402b', '#06504a', '#0c4a6e'], light: ['#b9f0d4', '#cffaf0', '#bdeefb'] },
  '#00b8d4': { name: 'Aqua', p: '#00b8d4', g: '#3aa0ff', a: '#00a3c4', rgb: '0, 184, 212', dark: ['#0a3f4d', '#0b3a6b', '#0a3a5e'], light: ['#bdeefb', '#caf0fb', '#c6dcfc'] },
}

/** Пресет по умолчанию — Cyber. */
export const DEFAULT_ACCENT = '#00b8d4'
